module.exports = __webpack_public_path__ + "img/Dantam Hair 06.344fe3da.jpg";